var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "transition",
    {
      attrs: {
        name: "fade"
      }
    },
    [
      !_vm.isHidden
        ? _c(
            "div",
            [
              _c("v-autocomplete", {
                ref: "autocomplete",
                attrs: {
                  label: "Search my websites & domains",
                  dense: "",
                  "hide-details": "",
                  clearable: "",
                  outlined: "",
                  "full-width": "",
                  "search-input": _vm.search,
                  "cache-items": false,
                  loading: _vm.isLoading,
                  items: _vm.searchItems
                },
                on: {
                  "update:searchInput": function updateSearchInput($event) {
                    _vm.search = $event
                  },
                  "update:search-input": function updateSearchInput($event) {
                    _vm.search = $event
                  },
                  change: _vm.selectSearchItem
                },
                model: {
                  value: _vm.selectedService,
                  callback: function callback($$v) {
                    _vm.selectedService = $$v
                  },
                  expression: "selectedService"
                }
              })
            ],
            1
          )
        : _vm._e()
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }